import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EventRule } from '@/features/event-rules/schemas/event-rules.schema.ts';

export const useDeleteEventRuleMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ eventRuleId }: Pick<EventRule, 'eventRuleId'>) => {
      return toast.promise(client.delete(`/events/rules/${eventRuleId}`), {
        loading: 'Deleting event rule...',
        success: 'Successfully deleted the event rule.',
        error: (_: unknown) => `Uh oh, there was an error with deleting the event rule.`,
      });
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['event-rules'] });
    },
  });
};
